const PaymentChannelValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (!values.institute_id) {
    // You can return translation keys
    errors.institute_id = "Institute is required";
  }

  if (!values.payment_method_id) {
    // You can return translation keys
    errors.payment_method_id = "Payment Method is required";
  }

  if (values.account_no) {
    if (!values.account_no.match(/^[0-9]{3}-[0-9]{1}-[0-9]{5}-[0-9]{1}$/)) {
      errors.account_no = "Account No. should match xxx-x-xxxxx-x";
    }
  }

  return errors;
};

export default PaymentChannelValidation;
